import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'

import { Input } from 'components/form/input'
import SizeSectionList from 'components/form/size-section-list'
import { useSelectedSizeGroup } from 'store/server/useOrderLookups'
import { matchSnapshot, zaraSizeName } from 'lib/matchCatalogSizes'
export default function BrandSizes({ idx,tab }) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()
  const { data: findSizeData } = useSelectedSizeGroup()

  useEffect(() => {
    if (!findSizeData?.sizes) return
    const snapshots = values.brandLabel[idx]?.sizes || []
    const preserve = !!(orderNo && snapshots.length > 0)
    const newSizes = findSizeData.sizes.map((item, idx2) => {
      const prev = preserve ? matchSnapshot(item, snapshots, idx2, { isHome: false }) : null
      const sizeValue = item.size?.includes('month') ? `${item.size} year` : item.size
      const sizeValue2 = item.size?.includes('month') ? `MONTH` : `YEARS`
      const isChild = findSizeData.name?.includes('ÇOCUK') || findSizeData.name?.includes('BEBEK')
      return {
        name: isChild ? String(sizeValue || '').split(' ')[0] : zaraSizeName(item, findSizeData),
        amount: prev?.amount || '',
        amountWithDefect: prev?.amountWithDefect || '',
        cn: item.cn,
        cm: item.cm,
        sCode: item.sCode || (item.europe != null ? String(item.europe) : ''),
        isMonth: sizeValue2 || '',
      }
    })
    setFieldValue(`brandLabel[${idx}].sizes`, newSizes)
  }, [findSizeData, orderNo, values.sizeGroup, idx, setFieldValue]);

  const totalAmount = values.brandLabel[idx].sizes?.reduce((acc, curr) => {
    if (curr.amount) return acc + parseInt(curr.amount)
    return acc
  }, 0)

  const totalAmountWithDefect = values.brandLabel[idx].sizes?.reduce((acc, curr) => {
    const amount = curr.amountWithDefect
    if (amount.length > 1) return acc + parseInt(amount)
    return acc
  }, 0)

  return (
    <div className="rounded border border-dashed p-2">
      <div className="mb-2 grid grid-cols-4 gap-x-5 text-sm font-medium text-simsek">
        <p>Beden</p>
        <p>Adet</p>
        <p>%</p>
        <p>Fireli Adet</p>
      </div>
      <div className="space-y-1">
        {values.brandLabel[idx].sizes.length < 1 ? (
          <div className="bg-rose-400 rounded p-2 text-center my-4">
            <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
          </div>
        ) : (
            <SizeSectionList
              catalogSizes={findSizeData?.sizes}
              rowCount={values.brandLabel[idx].sizes.length}
              renderRow={(index) => {
            const amount = values.brandLabel[idx].sizes[index]?.amount
            const percent =
              (values.brandLabel[idx].sizes[index]?.amount *
                values.brandLabel[idx].sizeDefectivePercent) /
                100 || 0
            const wastageQuantity = String(parseInt(amount) + parseInt(percent))
            return (
              <div className="grid grid-cols-4 gap-x-5" key={index}>
                <Input
                  name={`brandLabel[${idx}].sizes[${index}].name`}
                  disabled
                  autoComplete="off"
                />
                <Input
                  name={`brandLabel[${idx}].sizes[${index}].amount`}
                  onWheel={(e) => e.target.blur()}
                  autoComplete="off"
                />



                <Input name={`brandLabel[${idx}].sizeDefectivePercent`} autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`brandLabel[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`brandLabel[${idx}].sizeDefectivePercent`, n)
                  }}
                />

                <Input
                  name={`brandLabel[${idx}].sizes[${index}].amountWithDefect`}
                  autoComplete="off"
                  value={
                    values.brandLabel[idx].sizes[index].amount.length === 0
                      ? ' '
                      : wastageQuantity
                  }
                  disabled
                />
              </div>
            )
          }}
            />
        )}
        {values.brandLabel[idx].sizes.length > 0 && (
          <div className="grid grid-cols-4 gap-x-10">
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmount}</p>
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmountWithDefect}</p>
          </div>
        )}
      </div>
    </div>
  )
}
